import { formatEuroFr } from './editProductOutcome.js'

export const SHARE_CART_SEARCH_THRESHOLD = 8

export function articleCountLabel(count) {
  const n = Math.max(0, Number(count) || 0)
  return n === 1 ? '1 article' : `${n} articles`
}

export function isSharedCartUnavailable(cart, sharedCartId) {
  if (cart?.unavailable) return true
  if (sharedCartId && !cart) return true
  return false
}

export function sharedCartPreviewItems(cart, limit = 3) {
  const items = Array.isArray(cart?.preview_items) ? cart.preview_items : []
  return items.slice(0, limit).map((item, index) => ({
    id: item.id || `preview-${index}`,
    name: String(item.name || '').trim() || 'Produit',
    image_url: item.image_url || '',
    image_key: item.image_key || '',
  }))
}

export function shouldShowShareCartSearch(count) {
  return Number(count) >= SHARE_CART_SEARCH_THRESHOLD
}

export function filterCartsForShare(carts, query = '') {
  const needle = String(query || '').trim().toLowerCase()
  return (Array.isArray(carts) ? carts : []).filter((cart) => {
    if (!cart?.id) return false
    if (!needle) return true
    return String(cart.name || '').toLowerCase().includes(needle)
  })
}

export function lineSubtotal(item) {
  const price = Number(item?.price) || 0
  const quantity = Math.max(1, Number.parseInt(item?.quantity, 10) || 1)
  return price * quantity
}

export function previewItemRows(items) {
  return (Array.isArray(items) ? items : []).map((item, index) => {
    const quantity = Math.max(1, Number.parseInt(item?.quantity, 10) || 1)
    const unit = Number(item?.price) || 0
    return {
      id: item.id || `row-${index}`,
      name: String(item.name || '').trim() || 'Produit sans nom',
      image_url: item.image_url || '',
      quantity,
      unit,
      subtotal: unit * quantity,
    }
  })
}

export function sharedCartMetaLine(cart) {
  if (isSharedCartUnavailable(cart)) return 'Panier indisponible'
  const count = articleCountLabel(cart?.items_count)
  return `${count} · ${formatEuroFr(cart?.total)}`
}
